import { render } from "./AlurAlgoritmaKlinis.vue?vue&type=template&id=3f2f924a&scoped=true"
import script from "./AlurAlgoritmaKlinis.vue?vue&type=script&lang=js"
export * from "./AlurAlgoritmaKlinis.vue?vue&type=script&lang=js"

import "./AlurAlgoritmaKlinis.vue?vue&type=style&index=0&id=3f2f924a&lang=scss"
import "./AlurAlgoritmaKlinis.vue?vue&type=style&index=1&id=3f2f924a&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2f924a"]])

export default __exports__